import { render, staticRenderFns } from "./ConfirmationHome.vue?vue&type=template&id=754feaa7"
import script from "./ConfirmationHome.vue?vue&type=script&lang=js"
export * from "./ConfirmationHome.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationHome.vue?vue&type=style&index=0&id=754feaa7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports